import { useMemo } from 'react'

import { gql } from '../../__generated__/graphql/catalog'
import { usePreviewDirectives } from '../_providers/PreviewDirectivesProvider.client'

import { useNextQuery } from './useNextQuery'

/** Fetch & normalize the tooltip fixture data. */
export function useTooltipData() {
  const { includeUnpublishedCmsContent } = usePreviewDirectives()
  const { data, ...result } = useNextQuery(
    gql(`
      query GetTooltipData($handle: String!, $preview: Boolean = false) {
        siteFixtures(handle: $handle, preview: $preview) {
          __typename
          id
          tooltips {
            id
            contentType
            enumValue {
              name
            }
            title
            description
          }
        }
      }
    `),
    {
      variables: {
        handle: 'default',
        preview: includeUnpublishedCmsContent,
      },
    }
  )

  /* The tooltip fixtures with a content type of `colorCategory` */
  const colorCategoryTooltips = useMemo(
    () => data?.siteFixtures?.tooltips?.filter(t => t.contentType === 'colorCategory') ?? [],
    [data]
  )

  return { ...result, colorCategoryTooltips }
}
